import WebFont from 'webfontloader';
let didInclude = false;
const fontLoaderPlugin = (element, plugins) => {
    if (didInclude) {
        return;
    }
    const plugin = plugins === null || plugins === void 0 ? void 0 : plugins.find((p) => p.name === 'font-loader');
    if (plugin === null || plugin === void 0 ? void 0 : plugin.options) {
        WebFont.load(plugin.options);
        didInclude = true;
    }
};
export default fontLoaderPlugin;
